import { getLabelForAutotranslation, languageTagToLocalName } from 'js/lib/languageLocalized';

/**
 * Generates the label that will be used by the subtitle and transcription select
 */
function getSubtitleLabel(languageCode: string, isMachineTranslated: boolean) {
  const label = languageTagToLocalName(languageCode);
  const autoLabel = getLabelForAutotranslation(languageCode);

  if (isMachineTranslated) {
    return `${label} (${autoLabel})`;
  } else {
    return label;
  }
}

type SubtitleAssetTag = Record<
  string,
  {
    name: string;
    value: boolean;
  }[]
>;

type LanguageMap = {
  [language: string]: {
    label: string;
    url: string;
  };
};

function constructDubbedLanguageMap(dubbedSubtitlesVtt: Record<string, string>) {
  return Object.entries(dubbedSubtitlesVtt).reduce(
    (acc, [languageCode, url]) => ({
      ...acc,
      [languageCode]: {
        label: getSubtitleLabel(languageCode, false),
        url,
      },
    }),
    {} as LanguageMap
  );
}

function constructLanguageMap(subtitlesVtt: Record<string, string>, subtitlesAssetTags: SubtitleAssetTag | null) {
  const languageMap: LanguageMap = {};

  Object.keys(subtitlesVtt).forEach((languageCode) => {
    // We need to skip `__typename` because sometimes it will be included in the list of subtitles;
    if (languageCode === '__typename') return;

    const languageAssetTags = subtitlesAssetTags?.[languageCode] || [];
    const machineTranslationTagNames = ['machineTranslation', 'aiGenerated'];

    const isMachineTranslated = languageAssetTags.some(
      (entry) => machineTranslationTagNames.includes(entry.name) && entry.value
    );

    languageMap[languageCode] = {
      label: getSubtitleLabel(languageCode, isMachineTranslated),
      url: subtitlesVtt[languageCode],
    };
  });

  return languageMap;
}

export { constructLanguageMap, getSubtitleLabel, constructDubbedLanguageMap };
